import { styled } from '@mui/material';
import Dialog from '../Dialog';

const PREFIX = 'FormDialog';

export const formDialogClasses = {
  title: `${PREFIX}-title`,
  content: `${PREFIX}-content`,
  actions: `${PREFIX}-actions`,
  actionButton: `${PREFIX}-actionButton`,
  actionButtonLabel: `${PREFIX}-actionButtonLabel`,
  autoMarginRight: `${PREFIX}-autoMarginRight`,
  dangerButton: `${PREFIX}-dangerButton`,
  disabledButton: `${PREFIX}-disabledButton`,
};

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  [`& .${formDialogClasses.title}`]: {
    paddingTop: theme.spacing(2),
  },

  [`& .${formDialogClasses.content}`]: {
    marginBottom: theme.spacing(4),
  },

  [`& .${formDialogClasses.actions}`]: {
    margin: 0,
    padding: theme.spacing(1),
  },

  [`& .${formDialogClasses.actionButton}`]: {
    fontSize: '1rem',
  },

  [`& .${formDialogClasses.actionButtonLabel}`]: {
    fontSize: '0.8750em',
  },

  [`& .${formDialogClasses.autoMarginRight}`]: {
    marginRight: 'auto',
  },

  [`& .${formDialogClasses.dangerButton}`]: {
    color: theme.palette.error?.main || '#d32f2f',
  },

  [`& .${formDialogClasses.disabledButton}`]: {
    color: theme.palette.grey?.[500],
  },
}));